import ProjectPage from "../ProjectPage";

const ProjectSharePage2 = () => {
  const dummyProjects = [{
    __typename: "ProjectDTO",
    projectId: 17,
    name: "Meddelanden och Nyheter",
    description: "",
    linkedFolderId: null,
    projectFields: [],
    projectViews: []
  }];

  return (
    <ProjectPage
      selectedSiteId={7833}
      defaultProjects={dummyProjects}
      defaultProject={dummyProjects[0]}
      initialFile="/files/Wilma_Slutrapport1.pdf"
    />
  );
};

export default ProjectSharePage2;
